import { Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';

export default function NotFoundPage() {
  return (
    <Container className="text-center mt-5">
      <h1>404</h1>
      <p>Stranica nije pronađena.</p>
      <Link to="/">Povratak na početnu</Link>
    </Container>
  );
}
